import { useEffect } from "react";
import {  useSelector } from "react-redux";
import useDepartmentEditor from "../../../../../hooks/departments/useDepartmentsEditor";
import useDepartmentsGet from "../../../../../hooks/departments/useDepartmentsGet";
import { selectIsCreatingDepartment , selectIsEditingDepartment } from "../../../../../redux/departments/selectors";
import { Box, Grid, Text, Button, Input } from "@flexisaf/flexibull2";
import Theme from "../../../../../theme";
import { useForm } from "react-hook-form";
import fontSize from "../../../../../utils/typography";

const getDefaultFields = () => ({
  name: "",
});

const DepartmentEditor = (props) => {
  const isCreatingDepartment = useSelector(selectIsCreatingDepartment);
  const isEditingDeparment = useSelector(selectIsEditingDepartment);
  const {createDepartment,editDepartment} = useDepartmentEditor()
  const { refetch } = useDepartmentsGet();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      ...getDefaultFields(),
    },
  });

  useEffect(() => {
    if (props.data?.id) {
      setValue("name",  props?.data?.name );
    } 
  }, [props?.data, setValue]);


  const handleClose = () => {
    reset({
      ...getDefaultFields(),
    });
    props.closeModal();
  };

  const handleCreate = (v) => {
    let payload = {
      data: {
        ...v,
      },
      callback: () => {
        handleClose();
        refetch();
      },
    };
    createDepartment(payload);
  };

  const handleEdit = (v) => {
    let payload = {
      data: {
        id: props?.data?.id,
        ...v,
      },
      callback: () => {
        handleClose();
        refetch();
      },
    };
    editDepartment(payload);
  };

  return (
    <Box>
      <Grid default="auto max-content" responsive={false}>
        <Box pad="20px 20px">
          <Text {...fontSize.h3} uppercase>
            {props?.data?.id ? "Edit" : "Add a new"} Department
          </Text>
        </Box>
      </Grid>
      <Box pad="10px 20px">
        <Grid default="1fr" gap="24px">
          <Input
            spaceTop
            type="text"
            label={"Name"}
            required={true}
            placeholder={`Ex: Computer Science`}
            value={watch("name")}
            {...register("name", {
              required: `Name is required`,
            })}
            error={errors.name?.message}
            onChange={({ target: { value } }) => setValue("name", value)}
          />
        </Grid>
      </Box>

      <Grid default="auto max-content" responsive={false} >
        <Box pad="24px">
          <Button
            onClick={handleClose}
            pale
            color="rgba(0,0,0,0.0)"
            fontColor={Theme.PrimaryGrey}
          >
            Cancel
          </Button>
        </Box>
        <Box pad="24px">
          <Button
            onClick={handleSubmit((v) => {
              if (props?.data?.id) {
                handleEdit(v);
              } else {
                handleCreate(v);
              }
            })}
            progress={props?.data?.id ? isEditingDeparment : isCreatingDepartment}
          >
            {props?.data?.id ? "Edit" : "Create"}
          </Button>
        </Box>
      </Grid>
    </Box>
  );
};

export default DepartmentEditor;
